import { z } from 'zod';
import { zStringRequired } from '../../z';
export const otSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: z
            .object({
            onSiteVisit: zStringRequired(),
            maintainsOpenCommunication: zStringRequired(),
            arrivesAsScheduled: zStringRequired(),
            followsPlanOfCare: zStringRequired(),
            goalProgress: zStringRequired(),
            demonstratesCompetency: zStringRequired(),
            informsSupervisor: zStringRequired(),
            compliesWithInfectionControl: zStringRequired(),
            honorsClientRights: zStringRequired(),
            changesMadeToPlanOfCare: zStringRequired(),
            deficiencyIdentified: zStringRequired(),
            correctiveAction: z.string().optional(),
            comments: z.string().optional(),
        })
            .superRefine((data, ctx) => {
            if (data.deficiencyIdentified === 'yes' && !data.correctiveAction?.trim()) {
                ctx.addIssue({
                    path: ['correctiveAction'],
                    code: z.ZodIssueCode.custom,
                    message: 'required',
                });
            }
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
